import { render, staticRenderFns } from "./TsDragScroll.vue?vue&type=template&id=40e3c602&scoped=true&"
import script from "./TsDragScroll.vue?vue&type=script&lang=js&"
export * from "./TsDragScroll.vue?vue&type=script&lang=js&"
import style0 from "./TsDragScroll.vue?vue&type=style&index=0&id=40e3c602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3c602",
  null
  
)

export default component.exports